module.exports = __webpack_public_path__ + "../fonts/slick.ttf";


//////////////////
// WEBPACK FOOTER
// ./node_modules/slick-carousel/slick/fonts/slick.ttf
// module id = 282
// module chunks = 0